export default { sha: '7524f12acb172f35dd6391b1de934a07ef522145', buildNumber: 'undefined' }
